/**
 * A row the grid draws itself, never one of the caller's: a shimmer while a
 * page loads, or the retry line when the next page failed. Kept in the grid's
 * row data (not an overlay) so it sits exactly where the next rows will land,
 * the way a mobile list's footer spinner does.
 */
export interface LoaderRow {
  __dataGridLoader: 'shimmer' | 'error';
  index: number;
}

export function isLoaderRow(row: unknown): row is LoaderRow {
  return typeof row === 'object' && row !== null && '__dataGridLoader' in row;
}

export function loaderRows(kind: LoaderRow['__dataGridLoader'], count: number): LoaderRow[] {
  return Array.from({ length: count }, (_, index) => ({ __dataGridLoader: kind, index }));
}
